module.exports = __webpack_public_path__ + "static/media/clipboardInvestigacion.27cc6c29.png";